export default {"src":"/_next/static/media/InfoIconNew_16.7498a2ec.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};